export const INTRO_CLAMP_LINES = 5;

export function introClampMaxHeightPx(lineBottoms, lineCount = INTRO_CLAMP_LINES) {
  if(!Array.isArray(lineBottoms) || lineBottoms.length <= lineCount) return null;
  const height = lineBottoms[lineCount - 1];
  return Number.isFinite(height) ? height : null;
}

export function collectIntroLineBottoms(el) {
  if(!el || typeof el.querySelectorAll !== 'function') return [];

  const elTop = el.getBoundingClientRect().top;
  const fallbackLh = parseFloat(getComputedStyle(el).lineHeight) || 24;
  const range = document.createRange();
  const bottoms = [];
  const blocks = [...el.querySelectorAll('p, li')];
  const targets = blocks.length ? blocks : [el];

  targets.forEach((block) => {
    const lh = parseFloat(getComputedStyle(block).lineHeight) || fallbackLh;
    const blockTop = block.getBoundingClientRect().top;
    range.selectNodeContents(block);
    const rects = typeof range.getClientRects === 'function'
      ? [...range.getClientRects()].filter((rect) => rect.width > 0 && rect.height > 1)
      : [];
    const seen = new Set();

    if(!rects.length){
      const height = block.getBoundingClientRect().height;
      const count = Math.max(0, Math.round(height / lh));
      for(let i = 1; i <= count; i++){
        bottoms.push(blockTop + i * lh - elTop);
      }
      return;
    }

    rects.forEach((rect) => {
      const lineIndex = Math.max(0, Math.round((rect.top - blockTop) / lh));
      if(seen.has(lineIndex)) return;
      seen.add(lineIndex);
      bottoms.push(blockTop + (lineIndex + 1) * lh - elTop);
    });
  });

  return bottoms;
}
